<aside
  id="empty-component"
  class="flex flex-col justify-items-center justify-center"
  [ngStyle]="{ height: isMobile ? 'auto' : '15.75rem' }"
>
  <tui-block-status size="l" class="flex flex-col gap-2">
    <div>
      @if (icon) {
        <tui-avatar appearance="secondary-grayscale" [src]="icon" />
      }
    </div>
    <div class="flex flex-col gap-3">
      <h5 class="font-bold">{{ title }}</h5>
      <h6 class="font-medium">{{ description }}</h6>
    </div>
  </tui-block-status>
</aside>
